<template>
  <div class="content">
    
    <section class="h-100 gradient-form" style="background-color: #eee;">
      <div class="container py-5 h-100">
        <div class="row d-flex justify-content-center align-items-center h-100">
          <div class="col-xl-10">
            <div class="card rounded-3 text-black">
              <div class="row g-0">
                <div class="col-lg-6" style="background-color:#FFFFFF">
                  <div class="card-body p-md-5 mx-md-4">

                    <div class="text-center">
                      <img src="/img/logo-atrabajar.png"
                        style="width: 185px;" alt="logo">
                      <h4 class="mt-1 mb-5 pb-1">We are The Solucion Afore Team</h4>
                    </div>

                    <form>
                      <p>Proporcione la siguiente información para actualizar su Contraseña</p>

                      <div class="form-outline mb-4">
                        <input type="password" id="form2Example11" class="form-control" placeholder="Contraseña" />
                        <label class="form-label" for="form2Example11">Contraseña (mínimo 6 caracteres, mayusculas, minusculas y números)</label>
                      </div>

                      <div class="form-outline mb-4">
                        <input type="password" id="form2Example22" class="form-control" placeholder="Confirma Contraseña" />
                        <label class="form-label" for="form2Example22">Confirma tu Contraseña</label>
                      </div>

                      <div class="text-center pt-1 mb-5 pb-1">
                        <button @click="actualizar" class="btn btn-primary btn-block fa-lg gradient-custom-2 mb-3" type="button">Actualizar</button>
                        <a v-show="false" class="text-muted" href="#!">Olvidaste tu Contraseña?</a>
                      </div>

                      <div class="d-flex align-items-center justify-content-between pb-4">
                        <p class="mb-0 me-2">Tienes cuenta de acceso?</p>
                        <button type="button" class="btn btn-outline-danger">Crear</button>
                      </div>

                    </form>

                  </div>
                </div>
                <div class="col-lg-6 d-flex align-items-center gradient-custom-2" style="background-color:#0090CC">
                  <div class="text-white px-3 py-4 p-md-5 mx-md-4">
                    <h4 class="mb-4">We are more than just a company</h4>
                    <p class="small mb-0">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
                      tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
                      exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>


  </div>
</template>
<script>
  export default {
    props: {
      backgroundColor: {
        type: String,
        default: 'black',
        validator: (value) => {
          let acceptedValues = ['', 'blue', 'azure', 'green', 'orange', 'red', 'purple', 'black']
          return acceptedValues.indexOf(value) !== -1
        }
      },
    },
    data () {
      return {
        user: {
          email: 'correo@dominio.com'
        }
      }
    },
    methods: {
      actualizar(){
        
      },
      login(){
        this.$router.push("/admin/")
      }
    },
  }

</script>
<style>

</style>
